import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import g_logo from '../assets/logo_chancenwerk_white.svg';
import '../design/components/cr-button.js';
import '../design/components/cr-flex.js';
import '../design/components/cr-image.js';
import '../design/components/fonts.js';

/**
 * @customElement chancen-page-not-found
 */
@customElement('chancen-page-not-found')
export class ChancenPageNotFound extends ChemistryLitElement {
  @state() private readonly _size = new WindowSizeController(this);

  override render() {
    return html`
      <cr-flex padding="${this._size.mobile ? 'md' : 'xxl'}" space="xl" center crossaxis-center>
        <cr-image
          ${css({
            width: '80%',
            maxWidth: '30rem',
            filter: 'invert(53%) sepia(95%) saturate(478%) hue-rotate(28deg) brightness(115%) contrast(101%)',
          })}
          is-url
          .value="${g_logo}"
          mode="width"
        ></cr-image>
        <cr-h3> Wie bist du denn hier gelandet? </cr-h3>
        <cr-text> Die Seite, die du versuchst aufzurufen, konnte nicht gefunden werden. </cr-text>
      </cr-flex>
    `;
  }
}
